// @ts-nocheck
import useWidgetBadges from "@insite/client-framework/Common/Hooks/useWidgetBadges";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { VariantDisplayTypeValues } from "@insite/client-framework/Types/ApiModels";
import ProductAttributes, { ProductAttributesStyles } from "@insite/content-library/Components/ProductAttributes";
// import { ProductAvailabilityStyles } from "@insite/content-library/Components/ProductAvailability"; // Starter Custom Code
// import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand"; // Starter Custom Code
import ProductContextAvailability from "@insite/content-library/Components/ProductContextAvailability";
// import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription"; // Starter Custom Code
import ProductImageBadges from "@insite/content-library/Components/ProductImageBadges";
// import ProductPartNumbers, { ProductPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers"; // Starter Custom Code
import ProductTextBadges from "@insite/content-library/Components/ProductTextBadges";
import ProductListVariantSwatch from "@insite/content-library/Widgets/ProductList/ProductListVariantSwatch";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
// import React from "react"; //Starter Custom Code
import { connect } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { BreakpointKey } from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import {
    ProductAvailabilityStyles,
    useShowProductAvailability,
} from "@store/Overrides/Components/ProductAvailability";
import ProductBrand, { ProductBrandStyles } from "@store/Overrides/Components/ProductBrand";
import ProductDescription, { ProductDescriptionStyles } from "@store/Overrides/Components/ProductDescription";
import { ProductImageBadgesStyles } from "@store/Overrides/Components/ProductImageBadges";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@store/Overrides/Components/ProductPartNumbers";
import { ProductTextBadgesStyles } from "@store/Overrides/Components/ProductTextBadges";
// import { productCardProps } from "@store/Themes/common/props/productCard"; // Store Custom Code
import useIsBreakpoint from "@toolkit/Framework/Common/Hooks/useIsBreakpoint";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import React, { useMemo } from "react";

const mobileBreakpoint: BreakpointKey = "xs";
/* Starter Custom Code - End */

/* Store Custom Code - Start */
import FlexWrapper from "@store/Library/Components/Toolkit/FlexWrapper";
import { useProductListProductContext } from "@store/Framework/Components/ProductListProductContext/ProductListProductContext";
import ProductFullTruckLoad, { ProductFullTruckLoadStyles } from "@store/Library/Components/ProductFullTruckLoad";
import {
    hasMeaningfulMinimumOrderQuantity,
    resolveProductMinimumOrderQuantity,
} from "@store/Framework/Common/Utilities/productLineUtilities";
import ProductLeadTime, { ProductLeadTimeStyles } from "@store/Library/Components/ProductLeadTime";
import ProductLineMinimumOrderQuantity, {
    ProductLineMinimumOrderQuantityStyles,
} from "@store/Library/Components/ProductLine/ProductLineMinimumOrderQuantity";
import ProductShipsFrom, { ProductShipsFromStyles } from "@store/Library/Components/ProductShipsFrom";
import { productCardProps } from "@store/Themes/common/props/productCard";
import getBooleanProperty from "@toolkit/Framework/Common/Utilities/getBooleanProperty";
import { useCallback } from "react";
import { FlexWrapperPresentationProps } from "@store/Library/Components/Toolkit/FlexWrapper";

export interface ProductListProductInformationProps extends OwnProps {}
/* Store Custom Code - End */

interface OwnProps {
    showBrand: boolean;
    showTitle: boolean;
    showPartNumbers: boolean;
    showAvailability: boolean;
    showAttributes: boolean;
    showImageBadges?: boolean;
    maxImageBadges?: number;
    showTextBadges?: boolean;
    maxTextBadges?: number;
    // Starter Custom Code
    useAlternativeDisplayOnMobile?: boolean;
    // Store Custom Code
    showLeadTime?: boolean;
    showWarehouseAndFullTruckLoad?: boolean;
}

const mapStateToProps = (state: ApplicationState) => ({
    settingsCollection: getSettingsCollection(state),
});

type Props = ReturnType<typeof mapStateToProps> & OwnProps & HasProductContext;

export interface ProductListProductInformationStyles {
    container?: GridContainerProps;
    brandStyles?: ProductBrandStyles;
    descriptionStyles?: ProductDescriptionStyles;
    brandGridItem?: GridItemProps;
    descriptionGridItem?: GridItemProps;
    partNumbersGridItem?: GridItemProps;
    swatchGridItem?: GridItemProps;
    imageBadgeGridItem?: GridItemProps;
    textBadgeGridItem?: GridItemProps;
    partNumbersStyles?: ProductPartNumbersStyles;
    availabilityGridItem?: GridItemProps;
    availabilityStyles?: ProductAvailabilityStyles;
    attributesGridItem?: GridItemProps;
    attributes?: ProductAttributesStyles;
    searchScoreDataGridItem?: GridItemProps;
    // Starter Custom Code
    attributesWrapper?: InjectableCss;
    productTextBadges?: ProductTextBadgesStyles;
    productImageBadges?: ProductImageBadgesStyles;
    // Store Custom Code
    leadTimeStyles?: ProductLeadTimeStyles;
    shipsFromStyles?: ProductShipsFromStyles;
    ftlStyles?: ProductFullTruckLoadStyles;
    moreInfosWrapper?: InjectableCss;
    moreInfosFlexWrapper?: FlexWrapperPresentationProps;
    moreInfosLeadTimeFlexWrapper?: FlexWrapperPresentationProps;
    minimumOrderQuantityStyles?: ProductLineMinimumOrderQuantityStyles;
}

export const productInformationStyles: ProductListProductInformationStyles = {
    brandStyles: productCardProps.brand,
    descriptionStyles: mergeProps<ProductListProductInformationStyles["descriptionStyles"]>(
        productCardProps.description,
        {
            wrapper: {
                forwardAs: "h2",
            },
        },
    ),
    attributesWrapper: productCardProps.spacingWrapper,
    partNumbersStyles: productCardProps.partNumbers,
    attributes: productCardProps.attributes,
    availabilityStyles: productCardProps.availability,
    productTextBadges: productCardProps.textBadges,
    productImageBadges: productCardProps.imageBadges,
    /* Store Custom Code - Start */
    leadTimeStyles: productCardProps.leadTime,
    ftlStyles: productCardProps.fullTruckLoad,
    shipsFromStyles: productCardProps.shipsFrom,
    moreInfosWrapper: productCardProps.moreInfosWrapper,
    moreInfosFlexWrapper: productCardProps.moreInfosFlexWrapper,
    moreInfosLeadTimeFlexWrapper: productCardProps.moreInfosLeadTimeFlexWrapper,
    minimumOrderQuantityStyles: productCardProps.minimumOrderQuantity,
    /* Store Custom Code - End */
};

const styles = productInformationStyles;

const ProductListProductInformation = ({
    productContext,
    settingsCollection,
    showBrand,
    showTitle,
    showPartNumbers,
    showAvailability: baseShowAvailability, // Starter Custom Code
    showAttributes,
    showImageBadges,
    maxImageBadges,
    showTextBadges,
    maxTextBadges,
    // Starter Custom Code
    useAlternativeDisplayOnMobile,
    // Store Custom Code
    showLeadTime,
    showWarehouseAndFullTruckLoad,
}: Props) => {
    const showAvailability = useShowProductAvailability() && baseShowAvailability; // Starter Custom Code
    const { product } = productContext;
    /* Store Custom Code - Start */
    const productListProductContext = useProductListProductContext();

    const handleTitleClick = useCallback(() => {
        productListProductContext?.onTitleClick?.(true);
    }, [productListProductContext?.onTitleClick]);
    /* Store Custom Code - End */

    /* Starter Custom Code - Start */
    const isMobile = useIsBreakpoint(mobileBreakpoint, "down");

    const descriptionStyles = useMemo(() => {
        if (isMobile && useAlternativeDisplayOnMobile) {
            return mergeProps<ProductListProductInformationStyles["descriptionStyles"]>(styles.descriptionStyles, {
                wrapper: {
                    css: css`
                        font-size: ${x => x.theme.design.typography.size.base};
                    `,
                },
            });
        }
        return styles.descriptionStyles;
    }, [isMobile, useAlternativeDisplayOnMobile, styles.descriptionStyles]);

    const partNumbersStyles = useMemo(() => {
        if (isMobile && useAlternativeDisplayOnMobile) {
            return mergeProps<ProductListProductInformationStyles["partNumbersStyles"]>(styles.partNumbersStyles, {
                wrapper: {
                    css: css`
                        font-size: ${x => x.theme.design.typography.size.tiny};
                    `,
                },
            });
        }
        return styles.partNumbersStyles;
    }, [isMobile, useAlternativeDisplayOnMobile, styles.partNumbersStyles]);
    /* Starter Custom Code - End */

    if (!product) {
        return null;
    }

    const { imageBadges, textBadges } = useWidgetBadges({ productContext, showTextBadges, showImageBadges });

    let variantDisplayTrait = null;
    if (product.variantTraits && product.variantTraits.length > 0) {
        const swatchedViewList = [
            VariantDisplayTypeValues.SwatchDropdown,
            VariantDisplayTypeValues.SwatchList,
            VariantDisplayTypeValues.SwatchGrid,
        ];
        const sortedVaraintTraits = product.variantTraits.slice().sort((a, b) => a.sortOrder - b.sortOrder);
        variantDisplayTrait = sortedVaraintTraits.find(x => swatchedViewList.includes(x.displayType));
    }

    /* Store Custom Code - Start */
    const isGenericProduct = getBooleanProperty(productContext.product.properties.genericProduct);
    const minimumOrderQuantity = resolveProductMinimumOrderQuantity(productContext.product, productContext.productInfo);
    /* Store Custom Code - End */

    /* Starter Custom Code - Start */
    return (
        <>
            {product.brand && showBrand ? (
                <ProductBrand brand={product.brand} extendedStyles={styles.brandStyles} />
            ) : null}
            {/* Store Moved - ProductDescription - down */}
            {showPartNumbers || showAttributes ? (
                <StyledWrapper {...styles.attributesWrapper}>
                    {showPartNumbers && (
                        <ProductPartNumbers
                            productNumber={product.productNumber}
                            customerProductNumber={product.customerProductNumber}
                            manufacturerItem={product.manufacturerItem}
                            extendedStyles={partNumbersStyles}
                        />
                    )}
                    {showAttributes && (
                        <ProductAttributes maximumNumberAttributeTypes={3} extendedStyles={styles.attributes} />
                    )}
                </StyledWrapper>
            ) : null}
            {/* Store Custom Code - Start */}
            {showTitle ? (
                <ProductDescription
                    product={productContext}
                    extendedStyles={descriptionStyles}
                    // Store Custom Code
                    onClick={handleTitleClick}
                />
            ) : null}
            {/* Store Custom Code - End */}
            {showAvailability &&
                settingsCollection.productSettings.showInventoryAvailability /* Store Custom Code */ && (
                    <ProductContextAvailability extendedStyles={styles.availabilityStyles} />
                )}
            {variantDisplayTrait && (
                <ProductListVariantSwatch product={productContext} variantTrait={variantDisplayTrait} />
            )}
            {showTextBadges && textBadges && (
                <ProductTextBadges
                    badgeList={textBadges}
                    maxBadges={maxTextBadges ?? 4}
                    extendedStyles={styles.productTextBadges}
                />
            )}
            {showImageBadges && imageBadges && (
                <ProductImageBadges
                    badgeList={imageBadges}
                    maxBadges={maxImageBadges ?? 4}
                    extendedStyles={styles.productImageBadges}
                />
            )}
            {/* Store Custom Code - Start */}
            {!isGenericProduct && (
                <StyledWrapper {...styles.moreInfosWrapper}>
                    {showWarehouseAndFullTruckLoad && (
                        <FlexWrapper {...styles.moreInfosFlexWrapper}>
                            <ProductShipsFrom
                                extendedStyles={styles.shipsFromStyles}
                                displayIcons={true}
                                displayTexts={false}
                            />
                            <ProductFullTruckLoad
                                extendedStyles={styles.ftlStyles}
                                displayIcons
                                displayTexts={false}
                                displaySeparator
                            />
                        </FlexWrapper>
                    )}
                    {/* MOQ is independent of the lead time - it shows whether or not one is maintained */}
                    <FlexWrapper {...styles.moreInfosLeadTimeFlexWrapper}>
                        {showLeadTime && (
                            <ProductLeadTime
                                extendedStyles={styles.leadTimeStyles}
                                showShortLeadTimeDesc
                                displayLabel={false}
                            />
                        )}
                        {hasMeaningfulMinimumOrderQuantity(minimumOrderQuantity) && (
                            <ProductLineMinimumOrderQuantity
                                extendedStyles={styles.minimumOrderQuantityStyles}
                                minimumOrderQuantity={minimumOrderQuantity}
                            />
                        )}
                    </FlexWrapper>
                </StyledWrapper>
            )}
            {/* Store Custom Code - End */}
        </>
    );
    /* Starter Custom Code - End */
};

export default connect(mapStateToProps)(withProductContext(ProductListProductInformation));
